import { createSelector } from '@ngrx/store';
import { CorrectiveActionState } from '../reducers/corrective-action.reducer';

export const selectCorrectiveActionState = (state: any) =>
  state.correctiveAction;

export const selectCorrectiveAction = createSelector(
  selectCorrectiveActionState,
  (state: CorrectiveActionState) => state.correctiveAction
);

export const selectCorrectiveActionLoading = createSelector(
  selectCorrectiveActionState,
  (state: CorrectiveActionState) => {
    return state.loading;
  }
);
export const selectCorrectiveActionError = createSelector(
  selectCorrectiveActionState,
  (state) => state.error
);
